module.exports = __webpack_public_path__ + "static/media/no-data.9fd0468d.svg";